import {Alert, Button, Card, Space, Stack, Text, TextInput} from '@mantine/core'
import {useForm} from '@mantine/form'
import {notifications} from '@mantine/notifications'
import {createFileRoute} from '@tanstack/react-router'
import {useState} from 'react'

import logoLightUrl from 'src/assets/logo-light.svg'

import {apiFetch} from '../api/client'

export const Route = createFileRoute('/login')({
    component: LoginPage,
})

function LoginPage() {
    const [loading, setLoading] = useState(false)
    const [submitted, setSubmitted] = useState(false)

    const form = useForm({
        initialValues: {email: ''},
        validate: {
            email: (value) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '') ? null : 'Enter a valid email',
        },
    })

    async function onFinish(values: {email: string}) {
        setLoading(true)
        try {
            await apiFetch('/auth/login', {
                method: 'POST',
                body: JSON.stringify({email: values.email}),
            })
            setSubmitted(true)
        } catch (err) {
            notifications.show({
                color: 'red',
                message: err instanceof Error ? err.message : 'Login failed',
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                background: 'var(--mantine-color-brand-9)',
            }}
        >
            <Card w={360} style={{overflow: 'visible'}}>
                <Card.Section
                    withBorder
                    inheritPadding
                    py="md"
                    style={{display: 'flex', justifyContent: 'center'}}
                >
                    <img src={logoLightUrl} alt="AdvanceWell Analytics" height={32} />
                </Card.Section>
                <Card.Section inheritPadding py="md">
                    <Text style={{textAlign: 'center'}}>Log in to your account to continue.</Text>

                    <Space h="md" />

                    {submitted ? (
                        <Alert title="Check your email" color="green" variant="light">
                            If an account exists for that email, we've sent you a login link.
                        </Alert>
                    ) : (
                        <form onSubmit={form.onSubmit((values) => onFinish(values))}>
                            <Stack>
                                <TextInput
                                    label="Email"
                                    placeholder="you@example.com"
                                    size="md"
                                    autoFocus
                                    {...form.getInputProps('email')}
                                />
                                <Button
                                    type="submit"
                                    loading={loading}
                                    fullWidth
                                    size="md"
                                    color="green"
                                >
                                    Log In
                                </Button>
                            </Stack>
                        </form>
                    )}
                </Card.Section>
            </Card>
        </div>
    )
}
